import axios from "axios";
import * as moment from "moment";

import { ActionableTask } from "./models";

export class ActionableTasksApi {

    private readonly apiUrl = "/api/actionabletask";

    public async getAll(): Promise<ActionableTask[]> {
        const response = await axios.get(`${this.apiUrl}`);
        const data = response.data as ActionableTask[];
        return data.map(this.parseTaskModel);
    }

    private parseTaskModel(task: ActionableTask) {
        return {
            ...task,
            dateCreated: moment(task.dateCreated)
        };
    }
}
